import { createFileRoute } from "@tanstack/react-router";
import { redirectToHome } from "@/lib/locked-route";

// Locked for the MVP, like Insights: the address sends the person back Home. There is no approval step any more, and the
// change history (src/pages/GovernancePage.tsx) opens again with a later release.
export const Route = createFileRoute("/_authenticated/governance")({ beforeLoad: redirectToHome });
